module.exports = __webpack_public_path__ + "img/acca-powered.b39b9644.png";